import React, { useMemo, useState } from "react";
import { useQueries } from 'react-query'
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import { getPhaseRSC, getLongEventRSC, getLevelRSC, getUnit } from 'helpers/rsc'
import { getStats } from "data/Querys"
import NotAvailable from 'components/common/NotAvailable'
import Label from "components/general/Label";
import MirsTable from "components/general/table/Table";
import { ColumnName, ColumnNoc } from "components/common/TableColumns"
import { useViewport } from 'components/general/useViewPort'
import Loader from "components/general/Loader";
import Form from 'react-bootstrap/Form'
import 'styles/sports/sports.scss';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


const GlfPlayerstats = () => {
	const { breakPoint } = useViewport();
	const { mirs_competition, mirs_rsc, mirs_language } = useUrlFriendlyToParameters()
	const _longevent = getLongEventRSC(mirs_rsc);
	const _phase = getPhaseRSC(mirs_rsc);

	const _units = [
		_phase + '000100--'
		, _phase + '000200--'
		, _phase + '000300--'
		, _phase + '000400--'
	];
	let queryArray = [];

	//IND STATS BY PHASE
	queryArray.push({
		queryKey: ['stats', mirs_competition, mirs_language, _longevent, _phase + '000100--', 'IND_RANKING'],
		queryFn: getStats,
		refetchInterval: 10000,
		//staleTime: 10000,
		refetchIntervalInBackground: true,
		notifyOnChangeProps: ['data', 'error'],
	})

	//IND STATS BY UNIT
	_units.forEach((unit) => {
		queryArray.push({
			queryKey: ['playerstats', mirs_competition, mirs_language, unit, unit, 'IND_RANKING'],
			queryFn: getStats,
			refetchInterval: 10000,
			//staleTime: 10000,
			refetchIntervalInBackground: true,
			notifyOnChangeProps: ['data', 'error'],
		})
	});

	const results = useQueries(queryArray);

	const isLoading = results.some(result => result.isLoading)
	const isError = results.some(result => result.isError)

	if (isError) { return <NotAvailable />; }
	if (isLoading) { return <Loader />; }

	return (
		results[0]?.data?.stats ? <TableData results={results} breakPoint={breakPoint} /> : <NotAvailable />
	)

};

function TableData({ results, breakPoint }) {
	const { mirs_discipline } = useUrlFriendlyToParameters()
	const [statFilter, setStatFilter] = useState(['DRIVING', 'IMPERIAL']);
	const handleOnChange = (event => {
		setStatFilter(event.target.value.split(','))
	})
	const [hideMetres, setHideMetres] = useState(false)

	let competitors = results[0]?.data?.stats[0]?.statsCompetitors
	const _columns = useMemo(() => getColumns(results, breakPoint, mirs_discipline, statFilter, hideMetres), [statFilter, hideMetres]);

	return (
		<>
			<Form.Select
				className="my-2"
				id="selector-player-stats"
				//size="lg"
				//value='{paramsURL.mirs_event}'
				onChange={handleOnChange}>
				<option key='0' value='DRIVING,IMPERIAL'>
					<Label data="HeaderDrivingDistance" sport={mirs_discipline} />
				</option>
				<option key='1' value='DRIVE_ACC,DRIVES_FAIR,DRIVES_NUM'>
					<Label data="HeaderDrivingAccuracy" sport={mirs_discipline} />
				</option>
				<option key='2' value='GREENS,GREENS_REG,GREENS_NUM'>
					<Label data="HeaderGreensInRegulation" sport={mirs_discipline} />
				</option>
				<option key='3' value='SCRAMBLE,SCRAMBLE_PAR,SCRAMBLE_NUM'>
					<Label data="HeaderScrambling" sport={mirs_discipline} />
				</option>
				<option key='4' value='SAND_SAVE,SAND_MADE,SAND_ATT'>
					<Label data="HeaderSandSaves" sport={mirs_discipline} />
				</option>
				<option key='5' value='TEE_GAINED'>
					<Label data="HeaderStrokesGainedOfftheTee" sport={mirs_discipline} />
				</option>
				<option key='6' value='APPROACH_GAINED'>
					<Label data="HeaderStrokesGainedApproachtheGreen" sport={mirs_discipline} />
				</option>
				<option key='7' value='AROUND_GAINED'>
					<Label data="HeaderStrokesGainedAroundtheGreen" sport={mirs_discipline} />
				</option>
				<option key='8' value='PUTTS_GAINED'>
					<Label data="HeaderStrokesGainedPutting" sport={mirs_discipline} />
				</option>
				<option key='9' value='TOTAL_GAINED'>
					<Label data="HeaderStrokesGainedTotal" sport={mirs_discipline} />
				</option>
				<option key='10' value='DTP,IMPERIAL'>
					<Label data="HeaderProximitytoHole" sport={mirs_discipline} />
				</option>
				<option key='11' value='BIRDIES'>
					<Label data="HeaderTotalBirdies" sport={mirs_discipline} />
				</option>
				<option key='12' value='BOGEYS'>
					<Label data="HeaderTotalBogeys" sport={mirs_discipline} />
				</option>
			</Form.Select>

			{competitors && <MirsTable
				data={getRoundData(results, statFilter)}
				columns={_columns}
				showNavExtendedData={statFilter[0] === 'DRIVING' || statFilter[0] === 'DTP' ? true : false}
				extendedComponents={<ToggleGroup setMetres={setHideMetres}
					initialSortBy={[{ id: 'Rank', desc: false }]} />}
			/>}
		</>
	);
}

export default GlfPlayerstats;

function getRoundData(results, statFilter) {
	//Data es un array de units + acumulado 

	let athletes;
	let linesArray = []
	let rowData;
	let rowTable = []
	let arrayStat = statFilter;
	results?.map((result, index) => {
		let stats = result?.data?.stats?.find(x => x !== undefined) //es un array nos posicionamos en el primero ,  query solo devuelve 1 elemento
		let statsSource = stats?.statsItems?.find(statItem => statItem.type === 'ST' && statItem.code === 'ROUND')
		let rowStats = []

		if (index === 0) {
			athletes = stats?.statsCompetitors
		}

		athletes?.map((athlete, index) => {
			let athletesRound = stats?.statsCompetitors.find(competitor => competitor?.code === athlete?.code);
			let objStat = {};
			arrayStat && arrayStat.forEach((statFilter, index) => {
				if (index === 0) {
					objStat['stat' + index] = athletesRound?.statsItems?.find(stat => stat.code === statFilter)?.value
				} else {
					objStat['stat' + index] = athletesRound?.statsItems?.find(stat => stat.code === arrayStat[0])?.extendedStats?.find(extended => extended?.code === statFilter)?.value
				}
			})
			athletesRound && rowStats.push(objStat)
		})

		rowTable.push(rowStats)

	})

	athletes?.map((athlete, index) => {
		let sortOrder = athlete?.statsItems?.find(stat => stat.code === arrayStat[0])?.sortOrder
		let rank = athlete?.statsItems?.find(stat => stat.code === arrayStat[0])?.rank
		let rankEqual = athlete?.statsItems?.find(stat => stat.code === arrayStat[0])?.rankEqual
		rowData = {
			participant: athlete.participant,
			rank: rankEqual === 'Y' ? 'T' + rank : rank,
			sortOrder: sortOrder ? sortOrder : 1000,
			data0: rowTable[0][index],
			data1: rowTable[1][index],
			data2: rowTable[2][index],
			data3: rowTable[3][index],
			data4: rowTable[4][index],
		}
		linesArray.push(rowData)
	})

	return (
		linesArray.reverse() //revrse array order
	)
}

function getColumns(results, breakPoint, mirs_discipline, statFilter, hideMetres) {
	let colsAthletes;
	let colsData0;
	let colsData = [];

	results?.map((result, key) => {
		let stats = result?.data?.stats?.find(x => x !== undefined) //es un array nos posicionamos en el primero ,  query solo devuelve 1 elemento
		let label = '';
		let index = '1';
		index = getUnit(stats?.rsc).replaceAll('-', '').replaceAll('0', '')
		if (breakPoint === "sm" || breakPoint === "xs") {
			label = 'LabelRound' + index
		}

		let title = getLevelRSC(stats?.rsc) === 'EVENT'
			? 'LabelTotal'
			: (breakPoint === "sm" || breakPoint === "xs")
				? label
				: stats?.eventUnit?.shortDescription

		if (getLevelRSC(stats?.rsc) === 'EVENT') {
			colsAthletes = [
				{
					id: "Rank",
					Header: <Label data="HeaderRank" />,
					headerClassName: "w-5 text-center",
					className: "text-center",
					accessor: "sortOrder",
					Cell: (props) => (
						props.cell.row.original.rank
					)


				},
				ColumnNoc({ disableSort: true }),
				ColumnName({ disableSort: true }),
			]
			colsData0 = statFilter.length > 2 ?
				{
					id: "Data0",
					Header: <Label data="HeaderAverage" sport={mirs_discipline} />,
					headerClassName: "w-10 text-center",
					className: "text-center",
					accessor: "data0.stat1",
					Cell: (props) => {
						let row = props.cell.row.original.data0
						let intentos = row?.stat1 && row?.stat2 ? row?.stat1 + '/' + row?.stat2 : ''
						let percent = row?.stat0 ? row?.stat0 + '%' : ''
						return (
							<div className="m-0 row">
								<div className="col-lg-5 p-0 text-end glf-player-statistics-table">{intentos}</div>
								<div className="col-lg-7 p-0 text-end glf-player-statistics-table">{percent}</div>
							</div>
						)
					}
				} :
				{
					id: "Data0",
					Header: <Label data="HeaderAverage" sport={mirs_discipline} />,
					headerClassName: "w-10 text-center",
					className: "text-center",
					accessor: "data0.stat0",
					Cell: (props) => {
						const row = props.cell.row.original['data0']
						let value;
						if ((statFilter[0] === 'DRIVING' || statFilter[0] === 'DTP') && (hideMetres)) {
							value = row?.stat1
						} else {
							value = row?.stat0
						}
						return (
							<div className="glf-player-statistics-table">{value}</div>
						)
					}
				}
		} else {
			let objColumn = statFilter.length > 2 ?
				{
					id: "Data" + key,
					Header: <Label data={`LabelRound${key}`} sport={mirs_discipline} />,
					headerClassName: "w-10 text-center",
					className: "text-center",
					accessor: "data" + index + '.stat0',
					Cell: (props) => {
						const row = props.cell.row.original['data' + index]
						let intentos = row?.stat1 && row?.stat2 ? row?.stat1 + '/' + row?.stat2 : ''
						let percent = row?.stat0 ? row?.stat0 + '%' : ''
						return (
							<div className="row m-0">
								<div className="col-lg-5 p-0 text-end glf-player-statistics-table">{intentos}</div>
								<div className="col-lg-7 p-0 text-end glf-player-statistics-table">{percent}</div>
							</div>
						)
					}
				} :
				{
					id: "Data" + key,
					Header: <Label data={`LabelRound${key}`} sport={mirs_discipline} />,
					headerClassName: "w-10 text-center",
					className: "text-center",
					accessor: "data" + index + '.stat0',
					Cell: (props) => {
						const row = props.cell.row.original['data' + index]
						let value;
						if ((statFilter[0] === 'DRIVING' || statFilter[0] === 'DTP') && (hideMetres)) {
							value = row?.stat1
						} else {
							value = row?.stat0
						}
						return (
							<div className="glf-player-statistics-table">{value}</div>
						)
					}
				}
			colsData.push(objColumn)
		}

	})
	if (colsData0) { colsData.push(colsData0) }
	return (
		[...colsAthletes, ...colsData]
	)
}

const ToggleGroup = ({ setMetres }) => {
	const { mirs_discipline } = useUrlFriendlyToParameters()
	const types = [{ type: 'Metres', label: <Label data="HeaderMetres" sport={mirs_discipline} /> }, { type: 'Yardas', label: <Label data="HeaderImperial" sport={mirs_discipline} /> }];

	const [active, setActive] = useState(types[0].type);
	const handleClick = (e) => {
		setActive(e.target.value)
		setMetres(e.target.value === 'Metres' ? false : true)
	}
	return (
		<ButtonGroup onClick={handleClick}>
			{types.map((obj, index) => (
				<Button key={`btn-selector-${index}`} className='selector' variant="none" active={active === obj.type} value={obj.type}>{obj.label}</Button>
			))}
		</ButtonGroup>
	);
}